import Vue from 'vue'
import ScrollMagic from 'scrollmagic'

export const bus = new Vue();
export const smController = new ScrollMagic.Controller();

export const html = document.getElementsByTagName('html')[0];
export const body = document.getElementsByTagName('body')[0];

export const portraitIntroDuration = 100;

const getAudioContext = function () {
    if (typeof window.AudioContext !== 'undefined') {
        return new window.AudioContext();
    } else if (typeof window.webkitAudioContext !== 'undefined') {
        return new window.webkitAudioContext();
    } else if (typeof window.mozAudioContext !== 'undefined') {
        return new window.mozAudioContext();
    } else {
        return false;
    }
};

export const audioContext = getAudioContext();

export const mobileMq = '(max-width: 1023px)';

export const isIosDevice = (/iPad|iPhone|iPod/.test(window.navigator.platform));
export const isSafari = !!window.navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);



// WEBPACK FOOTER //
// ./src/consts.js